export enum AlertKeysEnum {
  AGEC_COMPLIANCE = "AGEC_COMPLIANCE",
  DUPLICATE_PRODUCTION_SITES = "DUPLICATE_PRODUCTION_SITES",
  INCOMING_LAUNCH_DATE = "INCOMING_LAUNCH_DATE",
  EXPIRED_LAUNCH_DATE = "EXPIRED_LAUNCH_DATE",
  EXPIRING_CERTIFICATES = "EXPIRING_CERTIFICATES",
}

export type AlertKey = keyof typeof AlertKeysEnum
